export default __webpack_public_path__ + "static/media/phoneme_prob_en.0262a087.png";